import React from 'react';

import {
  QuestionComponent,
  QuestionComponentProps
} from '../shared/QuestionComponent/QuestionComponent.react';

import {MultipleChoiceInputArea} from './MultipleChoiceInputArea.react';
import {MCQHowOthersAnswered} from './MCQHowOthersAnswered.react';

const MultipleChoiceQuestionComponent = ({
  actions,
  activeQuestion,
  activeQuestionSet,
  activeQuestionStore,
  activeSubject,
  customHeader,
  displayOrientation = 'default',
  guess,
  hasQuestionSetAccessPredicate,
  headingActions,
  interactive,
  isMobile,
  modifyTitle,
  navigateBackProps,
  navigateNextProps,
  postSubmissionScrollPointRef,
  showDifficulty,
  questionState
}: QuestionComponentProps) => {
  return (
    <QuestionComponent
      actions={actions}
      activeQuestion={activeQuestion}
      activeQuestionSet={activeQuestionSet}
      activeQuestionStore={activeQuestionStore}
      activeSubject={activeSubject}
      customHeader={customHeader}
      customHOA={<MCQHowOthersAnswered question={activeQuestion} />}
      displayOrientation={displayOrientation}
      guess={guess}
      hasQuestionSetAccessPredicate={hasQuestionSetAccessPredicate}
      headingActions={headingActions}
      interactive={interactive}
      isMobile={isMobile}
      modifyTitle={modifyTitle}
      navigateBackProps={navigateBackProps}
      navigateNextProps={navigateNextProps}
      postSubmissionScrollPointRef={postSubmissionScrollPointRef}
      questionState={questionState}
      showDifficulty={showDifficulty}
      ActiveQuestionInputArea={MultipleChoiceInputArea}
    />
  );
};

type MultipleChoiceQuestionTypeProps = Omit<QuestionComponentProps, 'questionState'>;

const MultipleChoiceQuestion = {
  PreGuess: (props: MultipleChoiceQuestionTypeProps) => (
    <MultipleChoiceQuestionComponent {...props} questionState='PreGuess' />
  ),
  PostGuess: (props: MultipleChoiceQuestionTypeProps) => (
    <MultipleChoiceQuestionComponent {...props} questionState='PostGuess' />
  )
};

export {MultipleChoiceQuestion};
